"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Types = require("../../../types");
const nodes_1 = require("../../../utils/nodes");
const _ActionTypes = require("./actionTypes");
const Tree_1 = require("./Tree");
function default_1(namespace, selectionMode) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        status: 'STANDBY',
        mode: Types.CLOSED,
        data: {
            status: 'STANDBY',
            error: undefined,
            total: 0,
            root: null,
            tree: null
        }
    };
    const methods = {};
    methods[ActionTypes.SET_ROOT] = (state, action) => {
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { root: action.root }) });
    };
    methods[ActionTypes.COPY_FILES_TOGGLE_OVERLAY] = (state, action) => {
        return Object.assign(Object.assign({}, state), { mode: action.mode });
    };
    methods[ActionTypes.USER_TOGGLE_COPY_OR_MOVE_RESULT] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'STANDBY' });
    };
    methods[ActionTypes.COPY_FILES_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'COPYING' });
    };
    methods[ActionTypes.COPY_FILES_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILURE' });
    };
    methods[ActionTypes.COPY_FILES_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'SUCCESS' });
    };
    methods[ActionTypes.COPY_FILES_RESET] = (state, action) => {
        return Object.assign({}, initialState);
    };
    methods[ActionTypes.FETCH_TREE_REQUEST] = (state, action) => {
        if (state.data.root) {
            const node = state.data.root.findNode((node) => node === action.payload.node);
            if (node) {
                node.setLoading(true);
            }
        }
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { status: 'FETCHING' }) });
    };
    methods[ActionTypes.FETCH_TREE_SUCCESS] = (state, action) => {
        let tree = null;
        let root = state.data.root;
        let target = state.target;
        let parent;
        if (root === null) {
            root = new Tree_1.Node((0, nodes_1.resolveRootNode)(action.data.node), selectionMode);
            /* tslint:disable-next-line */
            tree = new Tree_1.Tree(root);
            parent = root;
        }
        else {
            parent = root.findNode((node) => node.id === action.data.node.id);
            if (parent == null) {
                console.warn('node of the action is not part of the tree');
                return state;
            }
            const oldTree = root.getTree();
            if (oldTree) {
                tree = oldTree.clone();
            }
        }
        const rawTarget = target ? target.getValue() : undefined;
        parent.setLoading(false);
        const selectMode = parent.getSelectMode();
        const types = Array.isArray(action.data.types) ? action.data.types : [];
        const files = types.length > 0
            ? action.data.files.filter(({ type }) => types.includes(type))
            : action.data.files;
        const nodes = files.map((n) => {
            const node = new Tree_1.Node(n, selectMode);
            if (rawTarget && rawTarget.id === n.id) {
                target = node;
                node.setSelected(true);
            }
            return node;
        });
        parent.setChildren(nodes);
        return Object.assign(Object.assign({}, state), { target, data: Object.assign(Object.assign({}, state.data), { root,
                tree, loading: undefined, status: 'FETCHED' }) });
    };
    methods[ActionTypes.FETCH_TREE_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { tree: state.data.tree && state.data.tree.clone(), loading: undefined, status: 'FAILED' }) });
    };
    // "single select" for selection of possible target from the tree
    methods[ActionTypes.COPY_SELECT_TARGET] = (state, action) => {
        // reset any previous selections
        if (state.data.root !== null) {
            state.data.root.setSelected(false);
        }
        if (state.target) {
            state.target.setSelected(false);
        }
        action.target.setSelected(true);
        return Object.assign(Object.assign({}, state), { target: action.target, data: Object.assign(Object.assign({}, state.data), { tree: state.data.tree && state.data.tree.clone() }) });
    };
    // "multi select" to use when target is known and tree is used to pick files to be copied
    methods[ActionTypes.SELECT_FILE] = (state, action) => {
        action.node.setSelected(action.selected);
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { tree: state.data.tree && state.data.tree.clone() }) });
    };
    methods[ActionTypes.COPY_CHANGE_EXPAND] = (state, action) => {
        action.node.setExpanded(action.expand);
        return Object.assign(Object.assign({}, state), { data: Object.assign(Object.assign({}, state.data), { tree: state.data.tree && state.data.tree.clone() }) });
    };
    methods[ActionTypes.CLEAR] = () => (Object.assign({}, initialState));
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map